import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {Usuario} from "../../_model/";
import {config} from "../../../../environments/config";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";
import { IpServiceService } from '../ip/ip-service.service';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {
    private currentUserSubject: BehaviorSubject<Usuario>;
    public currentUser: Observable<Usuario>;

    now: any;

    constructor(
        private http: HttpClient,
        private router: Router,
        private ipService: IpServiceService,
    ) {
        this.currentUserSubject = new BehaviorSubject<Usuario>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        /*this.currentUser.subscribe(data => {
            if (data === null) {
                this.logout();
            }
        });*/
    }
    public get currentUserValue(): Usuario {
        return this.currentUserSubject.value;
    }

    login(username, password) {
        this.now = new Date();
        const params = new HttpParams()
            .set('username', username)
            .set('password', password);
        return this.http.post<any>(`${config.apiUrl}/login/auth`, params)
            .pipe(map(user => {
                if (user.dataset != null) {
                    localStorage.setItem('fecSesion', user.dataset.caducidad);
                }
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }
    logout() {
        // 
        localStorage.removeItem('currentUser');
        localStorage.removeItem('fecSesion');
        this.currentUserSubject.next(null);
        this.router.navigate(['/auth/login']);
     
    }
    recuperar(usuario,email,password) {
        const params = new HttpParams()
            .set('token', usuario)
            .set('ci', usuario)
            .set('email', email)
            .set('password', password);
        return this.http.post<any>(`${config.apiUrl}/recuperar/recuperar`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            });
    }
    getToken(): any {
        return JSON.parse(localStorage.getItem('currentUser'));
    }
    getSesion(): any {
        return localStorage.getItem('fecSesion');
    }
}
